<template>
  <v-container :class="multiple ? 'fluid grid-list-md': 'color-container'">
    <v-layout wrap class="color-filter-grid">
      <v-flex>
        <v-tooltip bottom>
          <div @click.stop="addColor('')" :class="['color blank', colors.includes('') ? 'selected' : '', small]" slot="activator"/>
          <span>{{ $tf('color.noColor') }}</span>
        </v-tooltip>
      </v-flex>
      <v-flex v-for="(col, index) in allColors" :key="col.color">
        <v-tooltip bottom>
          <div @click.stop="addColor(col.color)"
              slot="activator"
              :class="['color', colors.includes(col.color) ? 'selected' : '', small]"
              :style="{'background-color': col.color}"/>
          <span>{{ $tf('color.' + col.name.replace(' ', '')) }}</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'files-filter-action',
    props: {
      values: {
        type: Array,
        default: () => []
      },
      small: {
        type: String,
        default: ''
      },
      multiple: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        colors: []
      }
    },
    watch: {
      values (val) {
        this.colors = val
      }
    },
    mounted () {
      this.colors = this.values
    },
    computed: {
      allColors () {
        return this.$store.state.color.directories.hues
      }
    },
    methods: {
      addColor (selectedColor) {
        if (this.multiple) {
          if (this.colors.includes(selectedColor)) {
            this.colors = this.colors.filter(color => color !== selectedColor)
          } else {
            this.colors.push(selectedColor)
          }
          this.$emit('update-colors', this.colors)
        } else {
          this.colors = [selectedColor]
          this.$emit('update-colors', selectedColor)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .color-selector {
    display: block !important;
  }

  .color-container /deep/ .flex {
    flex: 1 1 auto;
  }

  .color {
    box-sizing: border-box;
    width: 36px;
    height: 36px;
    border-radius: 18px;
    margin: 5px 5px;
    &.blank {
      background: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 39%, rgba(255, 0, 0, 1) 40%, rgba(255, 0, 0, 1) 50%, rgba(255, 0, 0, 1) 60%, rgba(255, 255, 255, 1) 61%, rgba(255, 255, 255, 1) 100%);
      border: 5px solid red;
    }
    &.selected {
      border: 5px solid black !important;
    }
    &.small {
      width: 25px !important;
      height: 25px !important;
      padding: 5px 8px !important;
      &.selected {
        border: 3px solid black !important;
      }
      &.blank {
        border: 4px solid red;
      }
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/components/common/ColorPicker.vue